import React from 'react';
//mui imports====
import { Box } from '@mui/system';
import useStyles from './styles';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
//===============

const Sidebar = ({ selected, setSelected, componentsList }) => {
	const classes = useStyles();
	const handleChange = (e, newVal) => setSelected(newVal);
	return (
		<Box className={classes.sidebar}>
			<Tabs
				value={selected}
				onChange={handleChange}
				textColor="secondary"
				indicatorColor="secondary"
				orientation="vertical"
			>
				{selected &&
					Object.keys(componentsList).map((value) => {
						const tabClass =
							selected === value ? `${classes.tab} ${classes.selectedTabs}` : classes.tabs;

						return (
							<Tab
								value={value}
								className={tabClass}
								key={value}
								label={
									<TabContent
										icon={componentsList[value].icon}
										label={componentsList[value].label}
										value={value}
									/>
								}
							/>
						);
					})}
			</Tabs>
		</Box>
	);
};

const TabContent = ({ icon, label }) => {
	return (
		<Box style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
			{icon}
			<Typography variant="h6" marginLeft={2} textTransform="initial">
				{label}
			</Typography>
		</Box>
	);
};
export default Sidebar;
